import { Fragment, useRef, useState } from 'react'

import { Seo } from '../components'
import Button from '../components/tailwind/Button'
import PageHeading from '../components/tailwind/PageHeading'
import { useUserContext } from '../context'
import DemoChat from '../features/assistant-intro/DemoChat'
import LauncherShell from '../features/assistant-intro/launcher/LauncherShell'
import { LAUNCHER_VARIANTS } from '../features/assistant-intro/launcher/variants'

// Interne Showcase-Seite (nicht in der Sidebar verlinkt): alle Launcher-Varianten zum Durchschalten.
// Die gewaehlte Variante steht in ?v=, so laesst sich ein Link direkt auf eine Variante teilen.

const readVariant = () => {
  const id = new URLSearchParams(window.location.search).get('v')
  return LAUNCHER_VARIANTS.find((v) => v.id === id) || LAUNCHER_VARIANTS[0]
}

const AssistantLauncherDynamicPage = () => {
  const launcherRef = useRef(null)
  const { activeSpace } = useUserContext()
  const person = activeSpace?.person || {}
  const userName = person.firstname || person.invitation_firstname
  const [variant, setVariant] = useState(readVariant)
  const [thinking, setThinking] = useState(false)

  const choose = (id) => {
    const next = LAUNCHER_VARIANTS.find((v) => v.id === id)
    if (!next) return
    const url = new URL(window.location.href)
    url.searchParams.set('v', id)
    window.history.replaceState(null, '', url)
    setThinking(false)
    setVariant(next)
  }

  return (
    <Fragment>
      <Seo title='Aivy Assistent Launcher Varianten' />
      <PageHeading
        title='Aivy Assistent Launcher'
        subtitle='Varianten zum Durchschalten, der Launcher sitzt unten rechts'
        withActions={
          <div className='flex flex-wrap items-center gap-3'>
            <label className='sr-only' htmlFor='launcher-variant'>
              Variante
            </label>
            <select
              id='launcher-variant'
              value={variant.id}
              onChange={(e) => choose(e.target.value)}
              className='rounded-xl border-gray-300 py-2 pl-3 pr-9 text-sm font-medium text-gray-900 focus:border-[#407BFF] focus:ring-[#407BFF]'
            >
              {LAUNCHER_VARIANTS.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.name}
                </option>
              ))}
            </select>
            <Button.SecondaryXL
              onClick={() => launcherRef.current?.replay()}
              text='Intro abspielen'
            />
          </div>
        }
      />
      <div className='max-w-3xl px-4 py-8 sm:px-6 lg:px-8'>
        <div className='rounded-2xl border border-gray-200 bg-white p-5'>
          <div className='flex items-center gap-3'>
            <variant.Avatar size={40} />
            <h2 className='text-lg font-semibold text-gray-900'>
              {variant.name}
            </h2>
          </div>
          <p className='mt-3 text-sm leading-relaxed text-gray-700'>
            {variant.description}
          </p>
        </div>
        <div className='mt-6 text-sm leading-relaxed text-gray-600'>
          <p className='font-medium text-gray-900'>So probierst du es aus</p>
          <ul className='mt-2 list-disc space-y-1 pl-5'>
            <li>
              Maus langsam Richtung Button bewegen, die Figur reagiert schon
              vorher.
            </li>
            <li>
              Über den Button hovern und klicken, der Chat öffnet sich als
              Popout.
            </li>
            <li>
              Im Chat einen Vorschlag anklicken. Solange der Assistent
              nachdenkt, zeigt der Button das.
            </li>
          </ul>
          <p className='mt-4'>
            Auf dieser Seite läuft das Intro bei jedem Wechsel. Im echten
            Einsatz nur einmal pro Browser. Der Chat ist eine Demo ohne Backend.
          </p>
        </div>
      </div>
      <LauncherShell
        userName={userName}
        tooltipText='Heute sind 3 neue Ergebnisse reingekommen. Soll ich sie dir zeigen?'
        key={variant.id}
        ref={launcherRef}
        variant={variant}
        intro='always'
        thinking={thinking}
      >
        <DemoChat onThinkingChange={setThinking} />
      </LauncherShell>
    </Fragment>
  )
}

export default AssistantLauncherDynamicPage
